<script>
  import config from '../../libs/config.js';
	import { mapGetters, mapActions } from 'vuex'
	
	export default 
	{
		name: 'OnboardingPages',
		data() 
        {
        	return {}
        },
        computed: {
          ...mapGetters('session', ['getUser'])
        },
      methods: {
        ...mapActions('session', ['setUser']),
        ...mapActions('htmlModals', ['setOnboardingPages'])
      },
        created(){
        }
	}
</script>

<template>
<div  style="position: fixed; top: 0; right: 0; bottom: 0; left:0; background: rgba(15, 17, 26, 0.55) none repeat scroll 0% 0%; z-index: 9999; overflow: scroll;"
v-cloak>

    <div style="margin: 30px 0;" class="ui container">
        <div data-aos="fade-zoom-in" class="twelve wide computer sixteen wide mobile column centered">
            <div class="ui grid stackable">
                <div style="background: #fbfbfb;box-shadow: 0px 2px 54px rgba(39, 39, 39, 0.85);padding: 0; border-radius:5px;" class="eight wide computer sixteen wide mobile centered column">
                    <img style="border-radius:5px 5px 0 0;" class="ui fluid image" :src="'/img/inbox_pre.gif'" alt="">
                    <div class="ui basic big segment">
                    <h2>You're <span style="cursor:help;" title="Juphyrian is a person who signed up to Juphy and they care about their customers!" data-tooltip="Juphyrian is a person who signed up to Juphy." data-inverted="">Juphyrian!</span> 😻 🔮 </h2>
                    <p>You can add/remove multiple social accounts.</p>
                    <p>If you want to set active/passive an account, just click the activation slider. During Public Beta, you can add unlimited social accounts 🎉</p>
                    <div @click="setOnboardingPages(false)" class="ui button green fluid">Got it!</div>
                    </div>
                </div>
            </div>
        </div>
    </div>      
</div>      
</template>




// WEBPACK FOOTER //
// src/components/dashboard/OnboardingPages.vue